<template>
    <h5>All Existing User Groups</h5>

    <p class="card flex ">
        A UserGroup must be linked with a Datasource. To create a UserGroup, please edit an existing Datasource or
        create a new one that fits your needs.
    </p>

    <div class="card">
        <DataTable
            :value="userGroups"
            :lazy="true"
            :rowHover="true"
            paginator
            :rows="10"
            selectionMode="single"
            :loading="loading"
            @page="onPage"
            dataKey="id"
            :totalRecords="totalRecords"
            responsiveLayout="scroll"
            :rowsPerPageOptions="[2, 5, 10, 20, 50]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
        >
            <!--  @rowSelect="selectUserGroup" -->

            <template #empty> No user groups available. </template>
            <template #loading> Loading User Groups. Please wait. </template>
            <Column field="id" header="ID" style="width: 2rem" />
            <Column field="name" header="NAME" style="width: 8rem" />
            <Column field="description" header="DESCRIPTION" style="width: 18rem" />

            <Column field="users" header="Users" ref="users" key="userGroup.id" style="width: 2rem" >
                <template #body="slotProps">
                    <Button icon="pi pi-user" label="Users" :badge="slotProps.data.users.length.toString()" class="m-2 p-button p-button-warning" v-tooltip="'Show User Group members'" @click="toggleUserGroupMemberWindows(slotProps.data.users, slotProps.data.name)"> </Button>
                </template>
            </Column>

            <Column field="actions" header="ACTIONS" style="width: 11rem">
                <template #body="slotProps">
                    <Button icon="pi pi-eye" class="p-button-rounded p-button-primary mr-2" v-tooltip="'View Details'" @click="viewUserGroup(slotProps.data.id)" :disabled="!checkUserPermission(UserPermissions.READ_USER_GROUP)" />
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" v-tooltip="'Edit User Group'" @click="editUserGroup(slotProps.data.id)" :disabled="!checkUserPermission(UserPermissions.WRITE_USER_GROUP)" />
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2" v-tooltip="'Delete User Group'" @click="confirmDelete(slotProps.data.id)" :disabled="!checkUserPermission(UserPermissions.DELETE_USER_GROUP)" />
                </template>
            </Column>
        </DataTable>
    </div>


    <Dialog v-model:visible="userGroupWindowsShow" modal>
        <template #header>
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class=" white-space-nowrap">Members of UserGroup: <b>{{userGroupWindowsGroupName}}</b></span>
            </div>
        </template>

        <DataTable :value="userGroupWindowsMembers" :paginator="true" :rows="5" responsiveLayout="scroll">
            <template #empty> No Users available </template>
            <Column field="id" header="ID" />
            <Column field="name" header="Name" />
            <Column field="surname" header="Surname" />
        </DataTable>
    </Dialog>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { computed, onMounted, ref } from 'vue';
import GlobalRequest from '@/api/global-request';
import { useStore } from 'vuex';
import { UserPermissions } from '@/enums';
import useUserComposable from '@/composables/UserComposable';
import { showToast } from '@/helpers/toast-handler';
import { useConfirm } from 'primevue/useconfirm';
const router = useRouter();
const store = useStore();
const { checkUserPermission } = useUserComposable();
const confirm = useConfirm();

onMounted(async () => {
    loadUserGroup();
});

const onPage = async (event) => {
    paginationRows.value = event.rows;
    //Table data pages start with 0 not with 1.
    paginationPage.value = event.page + 1;

    loadUserGroup();
};

const userGroupWindowsShow = ref(false)
const userGroupWindowsGroupName = ref('')
const userGroupWindowsMembers = ref([])

function toggleUserGroupMemberWindows(users, userGroupName) {
    userGroupWindowsShow.value = true;
    userGroupWindowsGroupName.value = userGroupName;
    userGroupWindowsMembers.value = users;
}

const company_id = computed(() => {
    return store.getters['auth/userCompanyId']?.id;
});

const userGroups = ref([]);
const loading = ref(false);
const totalRecords = ref(0);
const paginationRows = ref(10)
const paginationPage = ref(1)

function viewUserGroup(userGroupId) {
    router.push({ name: 'ViewDatasourceUserGroups', params: { id: userGroupId } })
}

function editUserGroup(userGroupId) {
    router.push({ name: 'UpdateDatasourceUserGroups', params: { id: userGroupId } })
}

const confirmDelete = (id) => {
    confirm.require({
        message: 'Are you sure you want to delete UserGroup ' + id + '?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
            loading.value = true;
            GlobalRequest.deleteRequest('v2/datasource/users/'+id, {
                params: {
                    company_id: company_id.value,
                },
            }).then(() => {
                loadUserGroup();
            });
        },
        reject: () => {
            showToast({ summary: 'Rejected' }, 'Block not deleted');
        },
    });
};

function loadUserGroup() {
    loading.value = true;
    GlobalRequest.getRequest('v2/datasource/users', {
        params: {
            company_id: company_id.value,
            page_size: paginationRows.value,
            page: paginationPage.value,
            paginate: true,
            execute: true,
        },
    }).then((response) => {
        userGroups.value = response.data.data;
        totalRecords.value = response.data.total
    }).then(() => {
        loading.value = false;
    });
}
</script>
